import * as React from "react";
const SvgIcWindow = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M3.333 3.333h13.334v13.334H3.333V3.333ZM5 6.667V15h10V6.667H5Z" /></svg>;
export default SvgIcWindow;